import "./Panel.scss";
import { Box, useMediaQuery } from "@mui/material";
import Layout from "../../shared/Layout";
import Drawer from "./components/Drawer";
import Courses from "./components/Courses";
import { useState } from "react";

const Panel = () => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const isMobile = useMediaQuery("(max-width:1000px)");

  return (
    <Layout fullWidth="true">
      <Box sx={{ display: "flex", minHeight: "calc(100vh - 68px)" }}>
        <Drawer isOpenMenu={isOpenMenu} setIsOpenMenu={setIsOpenMenu} />
        {!(isMobile && isOpenMenu) && <Courses />}
      </Box>
    </Layout>
  );
};
export default Panel;
